import React, { useEffect } from 'react';
import { motion } from 'framer-motion';
import { ImagePlaceholder } from '../components/ImagePlaceholder';
interface AccentsCollectiveProps {
  title: string;
}
const placeholderText = 'text-stone-medium leading-relaxed italic';
export function AccentsCollective({
  title
}: AccentsCollectiveProps) {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);
  const container = {
    hidden: {
      opacity: 0
    },
    show: {
      opacity: 1,
      transition: {
        staggerChildren: 0.1,
        delayChildren: 0.1
      }
    }
  };
  const item = {
    hidden: {
      opacity: 0,
      y: 20
    },
    show: {
      opacity: 1,
      y: 0,
      transition: {
        duration: 0.8,
        ease: [0.19, 1, 0.22, 1]
      }
    }
  };
  return <motion.article variants={container} initial="hidden" animate="show" className="w-full pb-[0px]" data-id="element-110" data-mp="38iwg99oh8c0q">
      {/* Header Section */}
      <div className="max-w-4xl mx-auto px-6 md:px-12 mb-16 md:mb-24 text-center pt-12" data-id="element-111" data-mp="ivnc91pjet1b">
        <motion.h1 variants={item} className="text-4xl md:text-6xl font-bold text-ink tracking-tight mb-6" data-id="element-112" data-mp="nui6czsyg40q">
          {title}
        </motion.h1>
        <motion.p variants={item} className="text-xl md:text-2xl text-stone-medium font-light leading-relaxed max-w-3xl mx-auto mb-16" data-id="element-113" data-mp="hmmsi9b4k0lo">
          0→1 Brand & Business Building
        </motion.p>

        {/* Metadata Row */}
        <motion.div variants={item} className="grid grid-cols-1 md:grid-cols-3 gap-8 text-left border-t border-b border-stone-border py-8" data-id="element-114" data-mp="3lah8b6wsn64">
          <div data-id="element-115" data-mp="3uy55gim6icut">
            <h3 className="text-sm font-bold text-ink mb-2" data-id="element-116" data-mp="3q14xg25rr012">My role</h3>
            <p className="text-stone-medium text-sm italic" data-id="element-117" data-mp="3q1entquq797a">
              [Placeholder — your role]
            </p>
          </div>
          <div data-id="element-118" data-mp="3h0gr7tmma3yq">
            <h3 className="text-sm font-bold text-ink mb-2" data-id="element-119" data-mp="3h1006kuahi0m">Time frame</h3>
            <p className="text-stone-medium text-sm italic" data-id="element-120" data-mp="3c1dnqdmac5sv">
              [Placeholder — dates]
            </p>
          </div>
          <div data-id="element-121" data-mp="32di4ud2m9zqv">
            <h3 className="text-sm font-bold text-ink mb-2" data-id="element-122" data-mp="32cymiv9219cb">Scope</h3>
            <p className="text-stone-medium text-sm italic" data-id="element-123" data-mp="37ddxjg5v64r4">
              [Placeholder — brand, web, business]
            </p>
          </div>
        </motion.div>
      </div>

      {/* Hero Image */}
      <motion.div variants={item} className="w-full mb-16 md:mb-24 bg-[#F5F5F5] py-12" data-id="element-124" data-mp="2xe56ow6ap68z">
        <div className="max-w-7xl mx-auto px-6 md:px-12" data-id="element-125" data-mp="3l3zkbfyfuyua">
          <ImagePlaceholder label="Accents Collective hero image" aspect="aspect-[16/9] md:aspect-[21/9]" data-id="element-126" data-mp="3l6lr3ddi9abg" />
        </div>
      </motion.div>

      {/* Context and Challenge */}
      <div className="max-w-3xl mx-auto px-6 md:px-12 mb-24 space-y-16" data-id="element-127" data-mp="3gdj5breyz55t">
        <motion.section variants={item} data-id="element-128" data-mp="3gbg5kfo0lxnw">
          <h2 className="text-2xl font-bold text-ink mb-4" data-id="element-129" data-mp="7x7ifn49hz34">Context</h2>
          <p className={placeholderText} data-id="element-130" data-mp="7vwftqmjyxdl">
            [Placeholder — what Accents Collective is, who it serves, and why
            you started it.]
          </p>
        </motion.section>
        <motion.section variants={item} data-id="element-131" data-mp="1xcrythje1537">
          <h2 className="text-2xl font-bold text-ink mb-4" data-id="element-132" data-mp="1sga0azeni2zb">Challenge</h2>
          <p className={placeholderText} data-id="element-133" data-mp="274obbxm80xqy">
            [Placeholder — the core problem in building the brand and business
            from zero.]
          </p>
        </motion.section>
      </div>

      {/* Brand Foundation — Full Bleed */}
      <motion.section variants={item} className="mb-32" data-id="element-134" data-mp="1eh1wft7jm6os">
        <div className="max-w-4xl mx-auto px-6 md:px-12 text-center mb-12" data-id="element-135" data-mp="19gw0i0u8py0w">
          <h2 className="text-3xl font-bold text-ink mb-4" data-id="element-136" data-mp="19iqq3sggiebb">Brand foundation</h2>
          <p className="text-stone-medium mb-8 italic" data-id="element-137" data-mp="1nhgnl976ug07">
            [Placeholder — positioning, naming, and visual identity.]
          </p>
        </div>
        <div className="w-full bg-[#F5F5F5] py-12" data-id="element-138" data-mp="2yvkc3zv0bbxv">
          <div className="max-w-7xl mx-auto px-6 md:px-12" data-id="element-139" data-mp="2yu99i3dasa8c">
            <ImagePlaceholder label="Brand identity system (logo, color, type)" data-id="element-140" data-mp="2uus5zfhfln5t" />
          </div>
        </div>
      </motion.section>

      {/* Text + Image Modules */}
      <div className="max-w-7xl mx-auto px-6 md:px-12 mb-32 space-y-32" data-id="element-141" data-mp="3q6rssua7dtdl">
        <motion.section variants={item} className="grid grid-cols-1 lg:grid-cols-12 gap-12 items-center" data-id="element-142" data-mp="3u6ahm155aolp">
          <div className="lg:col-span-4" data-id="element-143" data-mp="7yix1pvym7fc">
            <h2 className="text-2xl font-bold text-ink mb-4" data-id="element-144" data-mp="7zll7q1wdvrk">
              Digital experience
            </h2>
            <p className={placeholderText} data-id="element-145" data-mp="cxdo1f42z2aj">
              [Placeholder — the website or storefront you designed and the key
              decisions behind it.]
            </p>
          </div>
          <div className="lg:col-span-8 w-full" data-id="element-146" data-mp="lrie3wbe49p0">
            <ImagePlaceholder label="Website / storefront screens" data-id="element-147" data-mp="qp0n1mpeqox0" />
          </div>
        </motion.section>

        <motion.section variants={item} className="grid grid-cols-1 lg:grid-cols-12 gap-12 items-center" data-id="element-148" data-mp="vowrto5xikdm">
          <div className="lg:col-span-4" data-id="element-149" data-mp="10o9eo8wsvrg7">
            <h2 className="text-2xl font-bold text-ink mb-4" data-id="element-150" data-mp="2l5ijno5zgevy">
              Building the business
            </h2>
            <p className={placeholderText} data-id="element-151" data-mp="2g6p3tp384bsm">
              [Placeholder — operations, launch, and growth work beyond design.]
            </p>
          </div>
          <div className="lg:col-span-8 lg:order-first w-full" data-id="element-152" data-mp="2b7kvf0o4ii3c">
            <ImagePlaceholder label="Launch, packaging, or marketing assets" data-id="element-153" data-mp="269b10sa83lis" />
          </div>
        </motion.section>
      </div>

      {/* Impact and outcome */}
      <motion.section variants={item} className="w-full bg-ink text-white py-32 px-6 md:px-12" data-id="element-154" data-mp="2ywx1vss2gc1y">
        <div className="max-w-4xl mx-auto text-center" data-id="element-155" data-mp="2u5orouiwwmnq">
          <h2 className="text-3xl md:text-4xl font-bold mb-8" data-id="element-156" data-mp="2u43z3ag5rdsi">
            Impact and outcome
          </h2>
          <p className="text-xl text-stone-medium font-light leading-relaxed italic" data-id="element-157" data-mp="2p59h2aq0lt9g">
            [Placeholder — results, metrics, or what you learned.]
          </p>
        </div>
      </motion.section>
    </motion.article>;
}